import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { Button } from '@nazka/nazka.mapframe.components';

import Modal from '@App/components/Modal/Modal';
import PasswordInput from '@App/components/PasswordInput/PasswordInput';
import PasswordTooltip from '@App/components/PasswordTooltip/PasswordTooltip';
import { setNewPassword } from '@services/auth.service';

import { validatePassword } from '../login-modal.utils';

function SetNewPassword({ email, session, onClose, onSuccess }) {
  const [newPassword, setNewPasswordValue] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState();
  const [repeatError, setRepeatError] = useState();

  const setNewPasswordMutation = useMutation({
    mutationFn: () => setNewPassword(email, session, newPassword),
    onSuccess,
  });

  return (
    <Modal
      title="Nieuw wachtwoord instellen"
      isOpen
      onClose={onClose}
      closeOnOverlayClick={false}
      className="login-modal"
    >
      <p className="login-modal__form__success">
        Je gebruikt een tijdelijk wachtwoord. Stel een nieuw wachtwoord in om verder te gaan.
      </p>
      <div className="login-modal__form">
        <label className={`login-modal__form__label${error ? ' login-modal__form__label--error' : ''}`}>
          <span className="login-modal__form__label__text">
            Nieuw wachtwoord
            <PasswordTooltip />
          </span>
          <PasswordInput
            className="login-modal__form__label__input"
            value={newPassword}
            onInputChange={setNewPasswordValue}
            placeholder="Wachtwoord"
          />
        </label>
        <label className={`login-modal__form__label${repeatError ? ' login-modal__form__label--error' : ''}`}>
          <span className="login-modal__form__label__text">
            Bevestig wachtwoord
          </span>
          <PasswordInput
            className="login-modal__form__label__input"
            value={confirmPassword}
            onInputChange={setConfirmPassword}
            placeholder="Herhaal wachtwoord"
          />
        </label>
        {(error || repeatError || setNewPasswordMutation.isError) && (
          <p className="login-modal__form__label__error">
            {error || repeatError || setNewPasswordMutation.error?.response?.data?.message || 'Er ging iets mis.'}
          </p>
        )}
      </div>
      <Button
        className="login-modal__submit-button"
        onClick={() => {
          const passwordError = validatePassword(newPassword);

          if (passwordError) {
            setError(passwordError);
            setRepeatError(null);
          } else if (newPassword !== confirmPassword) {
            setError(null);
            setRepeatError('Wachtwoorden komen niet overeen.');
          } else {
            setError(null);
            setRepeatError(null);
            setNewPasswordMutation.mutate();
          }
        }}
        isLoading={setNewPasswordMutation.isPending}
      >
        Wachtwoord instellen
      </Button>
    </Modal>
  );
}

export default SetNewPassword;
